import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaLock, FaShieldHalved } from "react-icons/fa6";
import { FiLogOut, FiRefreshCw } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearAuthStorage, showToast } from "../../lib/utility";
import { middleware, persistor } from "../../redux/store";
import { clearLogoutAuthState, logoutUser } from "../Auth/AuthSlice";
import "./noAccessPage.scss";

/** Full-page landing when the session has no dashboard it is allowed to open. */
const NoAccessPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  // Same sequence as the sidebar logout.
  const handleLogout = useCallback(() => {
    setIsLoggingOut(true);
    dispatch(logoutUser()).then((action) => {
      setIsLoggingOut(false);
      middleware(action, "Logout User", (action) => {
        dispatch(clearLogoutAuthState());
        clearAuthStorage();
        persistor.purge();
        document.body.classList.remove("dark-mode");
        navigate("/login");
        showToast(action.payload.message || "Logout successful", "success");
        globalThis.profileData = null;
      });
    });
  }, [dispatch, navigate]);

  return (
    <div className="no-access-page" role="alert">
      <div className="no-access-page__bg" aria-hidden="true">
        <span className="no-access-page__blob no-access-page__blob--one" />
        <span className="no-access-page__blob no-access-page__blob--two" />
        <span className="no-access-page__blob no-access-page__blob--three" />
        <span className="no-access-page__grid" />
      </div>

      <div className="no-access-page__card">
        <div className="no-access-page__icon" aria-hidden="true">
          <span className="no-access-page__ring" />
          <span className="no-access-page__ring no-access-page__ring--delay" />
          <FaShieldHalved className="no-access-page__shield" />
          <FaLock className="no-access-page__lock" />
        </div>

        <span className="no-access-page__badge">{t("noAccessPage.badge")}</span>
        <h1 className="no-access-page__title">{t("noAccessPage.title")}</h1>
        <p className="no-access-page__message">{t("noAccessPage.message")}</p>

        <div className="no-access-page__actions">
          <button
            type="button"
            className="no-access-page__btn no-access-page__btn--primary"
            onClick={handleRetry}
          >
            <FiRefreshCw aria-hidden="true" />
            {t("noAccessPage.retry")}
          </button>
          <button
            type="button"
            className="no-access-page__btn no-access-page__btn--ghost"
            onClick={handleLogout}
            disabled={isLoggingOut}
          >
            <FiLogOut aria-hidden="true" />
            {t("noAccessPage.logout")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoAccessPage;
